import { render } from "./HeaderSidebarNew.vue?vue&type=template&id=6675b7bc&scoped=true"
import script from "./HeaderSidebarNew.vue?vue&type=script&lang=js"
export * from "./HeaderSidebarNew.vue?vue&type=script&lang=js"

import "./HeaderSidebarNew.vue?vue&type=style&index=0&id=6675b7bc&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1184210722/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6675b7bc"]])

export default __exports__